import { Stack } from '@contrast-security-inc/design-system-layouts';
import { cx } from '@emotion/css';
import React, { forwardRef } from 'react';
export const ActionButtonGroup = forwardRef(({ testId, children, className, spacing = '8px', ...rest }, ref) => {
    return (React.createElement(Stack, { ...rest, className: cx(className, 'ds-action-button-group'), spacing: spacing, "data-testid": testId, ref: ref }, children));
});
ActionButtonGroup.displayName = 'ActionButtonGroup';
